import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../context/AppContext";

const EmailVerification = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { setIsLoading } = useAppContext();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("loading"); // loading | success | error
    const [messageKey, setMessageKey] = useState("");
    const calledOnce = useRef(false);

    useEffect(() => {
        if (calledOnce.current) return; // 👈 Prevent re-run
        calledOnce.current = true;

        const verifyEmail = async () => {
            const token = searchParams.get("token");
            if (!token) {
                setStatus("error");
                setMessageKey("errors.invalid_token");
                return;
            }

            setIsLoading(true);
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/verify-email?token=${token}`);
                const data = await res.json();

                if (data.success) {
                    setStatus("success");
                    setMessageKey(data.message);
                } else {
                    setStatus("error");
                    setMessageKey(data.message);
                }
            } catch (err) {
                setStatus("error");
                setMessageKey("errors.general");
            } finally {
                setIsLoading(false);
            }
        };

        verifyEmail();
    }, []);
    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: theme.palette.background.default,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
            }}
        >
            <Card
                sx={{
                    maxWidth: 400,
                    width: "100%",
                    bgcolor: theme.palette.sidebar?.background || theme.palette.background.paper,
                    boxShadow: 6,
                    borderRadius: 2,
                }}
            >
                <CardContent>
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        textAlign="center"
                        color={status === "success" ? theme.palette.primary.main : theme.palette.error.main}
                        mb={2}
                    >
                        {t(`emailVerification.titles.${status}`)}
                    </Typography>
                    <Typography
                        variant="body1"
                        textAlign="center"
                        mb={3}
                        color={theme.palette.text.primary}
                    >
                        {t(messageKey)}
                    </Typography>

                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => navigate("/login")}
                        sx={{
                            fontWeight: 500,
                            borderRadius: 2,
                            textTransform: "none",
                        }}
                    >
                        {t("emailVerification.backToLogin")}
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default EmailVerification;
